import fetch from '@/config/fetch';
import fetchNew from '@/config/fetchNew';


export const

  flashStandingBookPrice = data => fetchNew('/settlement/portAndWarehouse/flashStandingBookPrice', data, 'GET'),
  flashAdjustPrice = data => fetchNew('/settlement/portAndWarehouse/flashAdjustPrice', data, 'GET'),
  pushOne = data => fetch('/platform/settlement/accountCollect/summary/push', data, 'POST'),
  // 台账管理 台账明细 列表
  getAccountList = data => fetch('/platform/settlement/account/pageList', data, 'POST'),
  // 台账管理 台账明细 刷新实际结算价格
  refreshActualSettlementPrice = data => fetch('/platform/settlement/account/refreshActualSettlementPrice', data, 'POST'),
  adjustDifPrice = data => fetchNew('/settlement/account/adjustDifPrice', data, 'POST'),
  // 台账管理 台账明细 生成台账/提交调账 详情
  getAccountDetail = data => fetch('/platform/settlement/portAndWarehouse/addStandingBook', data, 'POST'),
  getAccountDetail2 = data => fetchNew('/settlement/portAndWarehouse/addStandingBook2', data, 'POST'),
  getAccountDetail3 = data => fetchNew('/settlement/portAndWarehouse/addStandingBook3', data, 'POST'),
  // 台账管理 台账明细 生成台账/提交调账 提交
  generateAccount = data => fetch('/platform/settlement/account/generateAccount', data, 'POST'),
  generateAccount1 = data => fetchNew('/settlement/account/generateAccount1', data, 'POST'),
  generateAccount2 = data => fetchNew('/settlement/account/generateAccount2', data, 'POST'),
  // 台账管理 台账明细 生成台账/提交调账 提交
  generateAccountByDifference = data => fetch('/platform/settlement/account/generateAccountByDifference', data, 'POST'),
  // 台账管理 台账明细 生成台账/提交调账 提交
  generateAccountByDifferenceBatch = data => fetch('/platform/settlement/account/generateAccountByDifferenceBatch', data, 'POST'),
  submit2 = data => fetchNew('/settlement/portAndWarehouse/submit2', data, 'POST'),
  generateAccountByDifferenceBatch2 = data => fetchNew('/settlement/account/generateAccountByDifferenceBatch2', data, 'POST'),
  // 台账管理 台账明细 纠错调账
  adjustAccountDetail = data => fetch('/platform/settlement/account/adjustAccountDetail', data, 'POST'),
  // 台账管理 台账明细 纠错调账 提交
  adjustAccountSubmit = data => fetch('/platform/settlement/account/adjust/submit', data, 'POST'),

  // 台账管理 台账明细 刷新结算
  refreshAccountList = data => fetch('/platform/settlement/account/addSettlementAccount', data, 'POST'),
  // 台账管理 财务分析
  getPageList = data => fetch('/platform/settlement/accountCollect/pageCountList', data, 'GET'),
  // 台账管理 汇总表 财务台账/财务调账
  getSummaryPageList = data => fetch('/platform/settlement/portAndWarehouse/accountCollect/getAccountCollectAll', data, 'GET'),
  // 台账管理 台账明细-板块一 查询
  getAccountCollectDetail = data => fetch('/platform/settlement/accountCollect/pageList', data, 'GET'),
  // 台账管理 台账明细-板块二 查询
  getAccountCoDetail = data => fetch('/platform/settlement/portAndWarehouse/accountCollect/getAccountCollectDetail', data, 'GET'),
  // 台账管理 台账明细-板块三 查询
  getAccountPageList = data => fetch('/platform/otherCost/standingBook/pageList', data, 'GET'),
  //台账管理 结算台账汇总 推送报错
  getError = (id,page,rows) => fetchNew(`/settlement/accountCollect/summary/getError?id=${id}&page=${page}&rows=${rows}`, {}, 'GET'),
  // 台账管理 台账汇总
  pageSbmCountList = data => fetch('/platform/settlement/accountCollect/summary/summaryQuery', data, 'GET'),
  // 台账管理 台账汇总 编辑台账编码
  editTheLedgerCode = data => fetch('/platform/settlement/accountCollect/summary/updateSummary', data, 'POST'),
  // 台账管理 删除
  deleteTheLedgerCode = data => fetch('/platform/settlement/accountCollect/detele', data, 'POST'),
  deleteAccount = data => fetch('/platform/otherCost/standingBook/deleteAccount', data, 'POST'),
  detele2 = data => fetch('/platform/settlement/portAndWarehouse/accountCollect/detele', data, 'POST'),
  // 台账管理 价格刷新
  getPriceRefresh = data => fetch('/platform/settlement/account/updateSettlementAccount', data, 'POST'),
  updateSettlementAccount3 = data => fetchNew('/settlement/account/updateSettlementAccount3', data, 'POST'),
  updateSettlementAccount4 = data => fetchNew('/settlement/account/updateSettlementAccount4', data, 'POST'),
  // 作废
  getPushList = data => fetch('/platform/settlement/accountCollect/summary/getPush', data, 'GET'),
  repeal = data => fetch('/platform/settlement/accountCollect/summary/repeal', data, 'POST');

